var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'es-skeleton': true,
    [`es-skeleton--border`]: _vm.border,
    [`es-skeleton--padding-${_vm.padding}`]: _vm.padding,
  }},[_c('div',{staticClass:"es-skeleton__animation"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }